import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';
import * as GoogleLibPhoneNumber from 'google-libphonenumber';
import { UserStore } from 'src/app/modules/authentication/state/user.store';

declare const $: any;

declare function preloadImg(flags: any): any;

@Component({
    selector: 'app-question-tel',
    templateUrl: './question-tel.component.html',
    styleUrls: ['./question-tel.component.scss'],
    standalone: false
})
export class QuestionTelComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = true;
  @Output() questionAnswer = new EventEmitter();
  user: any;
  uniqueControlName = `tel-${newGuid()}`;
  uniqueId = `tel-${newGuid()}`;
  value = '';
  prefix = '';
  selectedCode = '+27';
  countrySelectId = '#country-select'+this.uniqueId;
  phoneUtil: any;
  valid = true;
  constructor( private userStore: UserStore) {
    this.user = this.userStore.getValue();
    
  }

  ngOnInit(): void {
    this.phoneUtil = GoogleLibPhoneNumber.PhoneNumberUtil.getInstance();
    this.prefix = '+27 ';
    
  }

  ngAfterViewInit(): void {
    this.initFlags();
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;

      this.initFlags();

      if (this.question?.answer) {
        let answers = [];
        answers = this.question?.answer?.split(' ');
        if (answers?.length) {
          if (answers?.length === 2) {
            this.value = answers[1];
            this.selectedCode = answers[0];
            this.selectedCode = this.selectedCode.replace(/\s/g, '');

            if ($(this.countrySelectId).iconselectmenu('instance') && this.selectedCode) {
              setTimeout(() => {
                $(this.countrySelectId).val(this.selectedCode).iconselectmenu('refresh', true);
              }, 1000);
            }
          } else {
            this.value = answers[0];
          }
        } else {
          this.value = this.question?.answer;
        }
      }
      
    }
    if (changes?.readOnly?.currentValue !== changes?.readOnly?.previousValue) {
      this.readOnly = changes?.readOnly?.currentValue;
    }
    if (changes?.showLabel?.currentValue !== changes?.showLabel?.previousValue) {
      this.showLabel = changes?.showLabel?.currentValue;
    }
  }

  initFlags(): void {
    const targetInput = $(this.countrySelectId).attr('data-targetInput');
    $(this.countrySelectId)
      .iconselectmenu({
        icons: {button: ''},
        position: {
          my: 'left top',
          at: 'left bottom',
          collision: 'flip'
        },
        change: (event, data) => {
          this.value = '';
          this.prefix = '';
          if (data?.item?.value) {
            setTimeout(() => {
              this.prefix = data?.item?.value + ' ';
              $(targetInput).focus();
              // $(targetInput).val($(this.countrySelectId).val()).focus();
            }, 30);
          }
        }
      })
      .iconselectmenu('menuWidget')
      .addClass('ui-menu-icons ui-menu--country');

    // preload country flag images
    const flagImages = [];
    $('#country-select option').each(function() {
      const style = $(this).attr('data-style');
      const img = style.match(/\((.*)\)/)[1];
      flagImages.push(img);
    });
    preloadImg(flagImages);
  }

  saveValue(): void {
    this.valid = true;
    if (this.prefix && this.value && this.value?.length > 1) {
      try {
        const phoneNumber = this.phoneUtil.parseAndKeepRawInput(`${this.prefix}${this.value}`);
        if (this.phoneUtil.isValidNumber(phoneNumber)) {
          this.question.answer = `${this.prefix}${this.value.replace(/\s/g, '')}`;
        } else {
          this.question.answer = '';
          this.valid = false;
        }
      }
      catch { 
        this.question.answer = '';
        this.valid = false;
      }
    } else {
      this.question.answer = '';
      this.valid = false;
    }
    this.questionAnswer.emit(this.question);
  }
}
